import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const LoadingOverlay = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: ${props => props.$isVisible ? 1 : 0};
  visibility: ${props => props.$isVisible ? 'visible' : 'hidden'};
  transition: opacity 0.5s ease, visibility 0.5s ease;
`;

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #000;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.p`
  font-family: 'Cormorant Garamond', serif;
  font-size: 14px;
  color: #666;
  margin-top: 20px;
  letter-spacing: 0.5px;
  text-align: center;
  width: 100%;
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

interface PerformanceOptimizerProps {
  children: React.ReactNode;
}

const PerformanceOptimizer: React.FC<PerformanceOptimizerProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Brief loading screen while fonts and critical resources load
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  // Optimize font loading
  useEffect(() => {
    const fontUrl = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@300;400&display=swap';

    // Preload critical fonts (check if already exists)
    if (!document.querySelector(`link[rel="preload"][href="${fontUrl}"]`)) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = fontUrl;
      link.as = 'style';
      document.head.appendChild(link);
    }

    // Load fonts with display=swap for better performance (check if already exists)
    if (!document.querySelector(`link[rel="stylesheet"][href="${fontUrl}"]`)) {
      const fontLink = document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.href = fontUrl;
      document.head.appendChild(fontLink);
    }
  }, []);

  return (
    <>
      <LoadingOverlay $isVisible={isLoading}>
        <LoadingContainer>
          <LoadingSpinner />
          <LoadingText>VALEVENIO</LoadingText>
        </LoadingContainer>
      </LoadingOverlay>
      {children}
    </>
  );
};

export default PerformanceOptimizer;


